module.exports = __webpack_public_path__ + "imgs/CIF.4d677bf1ba52447632b4e222d9310548.png";